import mapTool from "./src/main.vue"
mapTool.install = function (Vue) {
  Vue.component(mapTool.name, mapTool)
}
export default mapTool
